<template>
  
  <div class="outtertablecell" :class="{ 'today': day.isToday }" v-for="day in week.days" :key="day.id">
    <calendar-day :day="day"></calendar-day>
  </div>
  
</template>

<script>
import CalendarDay from './CalendarDay.vue';
export default {  
  name: "CalendarWeek",
  components: { CalendarDay },
  props: ["week"]
}
</script>

<style>
.today {        
    border-color: darkcyan !important;
   /* border-width: 3px !important;
    border-style: outset !important; */
}
.todayText {        
    color: darkcyan !important;
   /* border-width: 3px !important;
    border-style: outset !important; */
}
</style>